/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RulerIcon = /*#__PURE__*/ createSvgIcon(
  'RulerIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M15.29 4.97L11.033.713.71 11.037l4.256 4.257L15.29 4.97zM8.98 2.77l2.5 2.5M6.91 4.83l1.48 1.48M4.85 6.9l2.5 2.5M2.78 8.96l1.48 1.48" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M19.291 6.141L13.868.718.708 13.878 6.133 19.3l13.16-13.16zM11.9 2.68l3.19 3.2M2.7 11.88l3.2 3.19M9.6 4.98l1.59 1.6M7.3 7.28l3.19 3.19M5 9.58l1.6 1.59" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M23.292 7.298l-6.59-6.59L.707 16.703l6.59 6.59L23.293 7.298zM14.3 3.11l3.89 3.88M3.13 14.28l3.88 3.88M11.51 5.9l1.94 1.94M8.72 8.69l3.88 3.88M5.93 11.49l1.94 1.94" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default RulerIcon;
